import { Map } from 'immutable'
import actions from './actions'

const {
    STAFF_PROFILES_FETCH_SUCCESS,
    STAFF_PROFILES_RESET,
    STAFF_PROFILES_SET_LOADING
} = actions

const initState = new Map({
    currentStaffId: '',
    loading: false
})

export default function userReducer (state = initState, action) {
    const result = action.result

    switch (action.type) {
        case STAFF_PROFILES_FETCH_SUCCESS:
            return state.mergeDeep({ currentStaffId: result })
        case STAFF_PROFILES_RESET:
            return initState
        case STAFF_PROFILES_SET_LOADING:
            return state.merge({ loading: action.loading })
        default:
            return state
    }
}
